import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import BabylonScene from './App';

ReactDOM.render(
  <React.StrictMode>
    <BabylonScene />
  </React.StrictMode>,
  document.getElementById('root')
);
